<template>
  <div class="page-view">
    <div class="component">
      <p class="h4 heading branding">
        Thank you! Your completed registration form has been successfully submitted!
        <span class="fa fa-check-circle text-success fa-lg"></span>
      </p>
      <h5 id="refnumber">
        Please save this reference number in case you need to contact us: <span>{{ referenceNumber }}</span>
      </h5>
      <div v-if="saveDraft">
        <p><a href="#" @click="goToResumedraft">If you want to resume the request, please click here.</a></p>
      </div>
      <p><b>What will happen next?</b></p>
      <div v-if="saveDraft">
        <p>A confirmation e-mail has also been sent to you with this number.</p>
      </div>
      <div v-else>
        <p>You will receive an email with this same information.</p>
        <p>
          Your submitted registration/agreement application form has been routed to the GE Aerospace business team for
          processing.
        </p>
        <p>
          We will review the information you have provided and contact you if any additional information or
          clarification is required in order to complete our processing of your application. You can expect an initial
          response to your application within 5-7 business days. If an agreement can be offered, you will be sent an
          agreement document to be signed and returned to GE Aerospace for execution and final processing.
        </p>
      </div>
      <p class="help-text">
        If you have any questions regarding the status of your request, please
        <a :href = customerSupportURL target="_blank" class="underline">Contact Our Support Team</a>
      </p>
      <div class="action-btns"><button type="submit" class="btn btn-sm btn-primary" @click="back">Close</button></div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isResumeDraftClicked: false,
      customerSupportURL: "https://www.cfmaeroengines.com/contact/"
    };
  },
  computed: {
    ...mapState("product", ["referenceNumber", "saveDraft"]),
    ...mapState("user", ["user"])
  },
  created() {
    if (!this.referenceNumber) {
      this.back();
    }
  },
  beforeDestroy() {
    if (!this.isResumeDraftClicked) {
      this.back();
    }
  },
  methods: {
    back() {
      this.$router.push("/");
      window.location.reload();
    },
    goToResumedraft() {
      if (this.referenceNumber) {
        this.isResumeDraftClicked = true;
        this.$router.push("/resume-draft?email=" + this.user.email + "&referenceNumber=" + this.referenceNumber);
        this.$store.dispatch("files/clearFiles");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.component {
  padding-left: 20px;
  padding-right: 20px;
}

#refnumber {
  font-size: 1.8rem;
  margin: 25px 0;

  span {
    font-weight: bold;
    color: green;
  }
}

.branding {
  font-size: 23px;
  color: #004bbd;
  font-family: apexSans;
}
</style>
